import React from 'react';
import Switch from "../../components/custom-antd/Switch";
import { STYLE_PREFIX } from "../../utils/const";
import "./style.less";
var SettingCard = function SettingCard(props) {
  var title = props.title,
    desc = props.desc,
    checked = props.checked,
    handleChange = props.handleChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "setting-card")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "setting-card-title")
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "setting-card-desc")
  }, desc)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Switch, {
    checked: checked,
    onChange: handleChange
  })));
};
export default SettingCard;